import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { UserProvider } from '@fff-web/fff-utilities';
import { initialize } from '@fff-web/fff-analytics';
import { initializeDatadogRum, initializeDatadogLogs } from './utils/datadog';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_CONTAINER_ID,
};

TagManager.initialize(tagManagerArgs);

initialize();
initializeDatadogRum();
initializeDatadogLogs();

globalThis.window.FFF = { ...globalThis.window.FFF };
globalThis.window.FFF[process.env.APP_NAME] = {
  version: process.env.APP_VERSION,
  libs: process.env.APP_LIBS,
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
